const translations = {
  es: {
    // Common
    app_name: 'El Club de Manri',
    save: 'Guardar',
    cancel: 'Cancelar',
    next: 'Siguiente',
    previous: 'Anterior',
    confirm: 'Confirmar',
    loading: 'Cargando...',
    error: 'Error',
    logout: 'Salir',
    close: 'Cerrar',
    search: 'Buscar',
    welcome: 'Bienvenidos',
    room: 'Email',

    // Login
    login_title: 'Iniciar sesion',
    login_subtitle: 'Accede a tu cuenta de El Club de Manri',
    register_title: 'Crear cuenta',
    register_subtitle: 'Registra tu familia para reservar talleres',
    email_label: 'Email',
    password_label: 'Contrasena',
    family_name_label: 'Nombre de la familia',
    login_button: 'Entrar',
    register_button: 'Crear cuenta',
    toggle_to_register: 'No tengo cuenta - Registrarme',
    toggle_to_login: 'Ya tengo cuenta - Iniciar sesion',
    login_hero_text: 'Gestion de actividades y talleres infantiles inspirado en el arte de Cesar Manrique',
    account_created: 'Cuenta creada correctamente',
    invalid_credentials: 'Credenciales incorrectas',

    // Registration Wizard
    wizard_title: 'Registro Familiar',
    wizard_subtitle: 'Completa los datos para acceder al El Club de Manri',
    step_family: 'Datos Familia',
    step_phone: 'Verificar Telefono',
    step_pool: 'Mapa Piscina',
    step_consents: 'Consentimientos',
    step_confirm: 'Confirmacion',
    family_data_title: 'Datos de la Familia',
    room_number_label: 'Correo electronico',
    children_label: 'Hijos/as',
    add_child: 'Anadir',
    child_name: 'Nombre',
    child_age: 'Edad',
    phone_title: 'Verificacion de Telefono',
    phone_subtitle: 'Introduce tu numero para recibir un codigo SMS',
    send_sms: 'Enviar SMS',
    sending: 'Enviando...',
    sms_sent: 'Codigo SMS enviado (simulado)',
    test_code: 'Codigo de prueba (SMS simulado)',
    verify_code: 'Verificar Codigo',
    verifying: 'Verificando...',
    phone_verified: 'Telefono verificado',
    verify_first: 'Verifica tu telefono primero',
    pool_title: 'Mapa de la Piscina',
    pool_subtitle: 'Selecciona una zona o haz clic en el area libre para indicar tu ubicacion',
    pool_location: 'Ubicacion',
    pool_zone: 'Zona',
    pool_free: 'Posicion libre',
    select_location: 'Selecciona tu ubicacion en el mapa',
    signatures_title: 'Firmas Digitales',
    signatures_subtitle: 'Firma los siguientes documentos con el dedo o lapiz',
    auth_title: 'Autorizacion General',
    auth_text: 'Autorizo a mi/s hijo/s a participar en las actividades del El Club de Manri del hotel, incluyendo talleres, juegos y actividades supervisadas por los monitores.',
    terms_title: 'Terminos y Condiciones',
    terms_text: 'Acepto los terminos y condiciones del servicio El Club de Manri, incluyendo las normas de comportamiento, horarios y responsabilidades.',
    image_title: 'Derecho de Imagen',
    image_text: 'Autorizo al hotel a capturar y utilizar fotografias y videos de mi/s hijo/s durante las actividades del El Club de Manri con fines promocionales.',
    sign_instruction: 'Firme con el dedo o lapiz en el area superior',
    all_signatures_required: 'Todas las firmas son obligatorias',
    confirm_title: 'Todo listo!',
    confirm_subtitle: 'Revisa los datos y confirma tu registro',
    family_label: 'Familia',
    phone_label: 'Telefono',
    verified: 'verificado',
    documents_signed: 'documentos firmados',
    complete_registration: 'Confirmar Registro',
    completing: 'Completando...',
    registration_complete: 'Registro completado!',
    saving: 'Guardando...',
    fill_name_room: 'Completa nombre y correo electronico',
    add_one_child: 'Anade al menos un hijo/a',

    // Dashboard
    tab_workshops: 'Talleres',
    tab_reservations: 'Mis Reservas',
    tab_history: 'Historial',
    workshops_available: 'Talleres Disponibles',
    calendar_view: 'Calendario',
    list_view: 'Lista',
    no_reservations: 'No tienes reservas activas',
    my_reservations: 'Mis Reservas',
    children_label: 'Ninos',
    cancel_reservation: 'Cancelar Reserva',
    reservation_confirmed: 'Confirmada',
    checked_in: 'Check-in',
    book: 'Reservar',
    reserved: 'Reservado',
    full: 'Completo',
    capacity: 'plazas',
    ages: 'Edades',
    years: 'anos',
    select_children: 'Seleccionar Hijos/as',
    confirm_booking: 'Confirmar Reserva',
    booking_confirmed: 'Reserva confirmada!',
    select_one_child: 'Selecciona al menos un hijo/a',
    reservation_cancelled: 'Reserva cancelada',
    workshop_full: 'Taller completo',

    // History
    history_title: 'Historial de Actividades',
    activities: 'Actividades',
    attendances: 'Asistencias',
    total_hours: 'Horas Totales',
    unique_workshops: 'Talleres Unicos',
    child_progress: 'Progreso por Hijo/a',
    workshops_count: 'talleres',
    timeline: 'Cronologia de Actividades',
    attended: 'Asistio',
    no_activities: 'Sin actividades aun',
    activities_appear_here: 'Las reservas y actividades apareceran aqui',
    participants: 'Participantes',

    // Reviews
    rate_workshop: 'Valorar este taller',
    how_was_experience: 'Como fue la experiencia?',
    write_comment: 'Escribe un comentario (opcional)...',
    send: 'Enviar',

    // Calendar
    workshops_this_week: 'talleres esta semana',
    workshop_singular: 'taller',
    today: 'Hoy',
    filter: 'Filtrar',
    all: 'Todos',
    none: 'Ninguno',
    categories_of: 'de',
    categories: 'categorias',
    no_workshops_day: 'No hay talleres este dia',
    no_workshops_week: 'No hay talleres esta semana',
    navigate_hint: 'Navega a otra semana con las flechas',

    // Pool zones
    zona_a: 'Zona A', zona_b: 'Zona B', zona_c: 'Zona C', zona_d: 'Zona D', zona_e: 'Zona E',
    main_pool: 'Piscina Principal', kids_pool: 'Piscina Infantil',

    // Pool Map
    pool_click_hint: 'Haz clic en el mapa para marcar la ubicacion',
    pool_main: 'Piscina Principal',
    pool_2: 'Piscina 2',
    pool_3: 'Piscina 3',
    location_marked: 'Ubicacion marcada',

    // Admin Dashboard
    admin_title: 'Admin',
    admin_subtitle: 'Panel de administracion',
    export_pdf: 'Exportar PDF',
    workshop_management: 'Gestion de Talleres',
    new_workshop: 'Nuevo Taller',
    create_workshop: 'Crear Taller',
    update_workshop: 'Actualizar Taller',
    access_type: 'Tipo de acceso',
    mandatory_registration: 'Registro obligatorio',
    free_access: 'Acceso libre',
    families_must_book: 'Las familias deben reservar plaza para esta actividad',
    families_can_access: 'Las familias pueden acceder sin reserva previa',
    schedule: 'Horario',
    morning: 'AM - Manana',
    afternoon: 'PM - Tarde',
    materials_needed: 'Materiales necesarios',
    materials_placeholder: 'Ej: Pinturas, pinceles, papel...',
    pool_zone_label: 'Zona de la piscina',
    drive_link_label: 'Enlace Google Drive (recursos)',
    mandatory_badge: 'Obligatorio',
    free_badge: 'Libre',
    tab_talleres: 'Talleres',
    tab_calendario: 'Calendario',
    tab_familias: 'Familias',
    tab_reservas: 'Reservas',
    tab_valoraciones: 'Valoraciones',
    tab_qr: 'Codigo QR',

    // Monitor Dashboard
    monitor_title: 'Monitor',
    monitor_subtitle: 'Panel de control diario',
    reservations_today: 'Reservas Hoy',
    checkins: 'Check-ins',
    active_workshops: 'Talleres Activos',
    families: 'Familias',
    tab_checkin: 'Check-in',
    tab_schedule_today: 'Horario Hoy',
    tab_tomorrow: 'Manana',
    workshops_of_day: 'Talleres del Dia',
    activities_today: 'Actividades de Hoy',
    activities_tomorrow: 'Actividades de Manana',
    no_activities_today: 'No hay actividades programadas para hoy',
    no_activities_tomorrow: 'No hay actividades programadas para manana',
    search_family: 'Buscar familia...',
    no_reservations_filter: 'No hay reservas',
    no_reservations_workshop: 'No hay reservas para este taller',
    present: 'Presente',
    filter_btn: 'Filtrar',
    filtered: 'Filtrado',
    reservations_count: 'reservas',
    spots: 'plazas',
    registration_label: 'Registro',
    free_label: 'Libre',
    resources: 'Recursos',

    // Workshop Detail Modal
    description_label: 'Descripcion',
    no_description: 'Sin descripcion',
    materials_section: 'MATERIALES NECESARIOS',
    not_specified: 'No especificados',
    location_label: 'UBICACION',
    not_assigned: 'NO ASIGNADA',
    open_drive: 'Abrir carpeta Google Drive',
    drive_resources: 'Recursos digitales y archivos de la actividad',
    drive_not_configured: 'Sin enlace configurado',
    google_drive: 'Google Drive',
    photos: 'Fotos',
    no_photos: 'Sin fotos adjuntas',
    no_digital_resources: 'No hay recursos digitales adjuntos a esta actividad',
    qr_today_label: 'Hoy',
    years_old: 'anos',

    // Login
    login_hero: 'Gestion de actividades y talleres infantiles',

    // Scan Page
    parent_name_label: 'Nombre del padre/madre/tutor',
    dni_label: 'DNI / NIE / Pasaporte',
    parent_required: 'Nombre del padre/madre/tutor es obligatorio',
    dni_required: 'DNI/NIE/Pasaporte es obligatorio',
    email_password_required: 'Email y contrasena son obligatorios',
    qr_verified: 'QR Verificado',
  },

  en: {
    app_name: 'El Club de Manri',
    save: 'Save',
    cancel: 'Cancel',
    next: 'Next',
    previous: 'Previous',
    confirm: 'Confirm',
    loading: 'Loading...',
    error: 'Error',
    logout: 'Log out',
    close: 'Close',
    search: 'Search',
    welcome: 'Welcome',
    room: 'Email',

    login_title: 'Sign in',
    login_subtitle: 'Access your El Club de Manri account',
    register_title: 'Create account',
    register_subtitle: 'Register your family to book workshops',
    email_label: 'Email',
    password_label: 'Password',
    family_name_label: 'Family name',
    login_button: 'Sign in',
    register_button: 'Create account',
    toggle_to_register: "I don't have an account - Sign up",
    toggle_to_login: 'I already have an account - Sign in',
    login_hero_text: 'Kids activities and workshops management inspired by the art of Cesar Manrique',
    account_created: 'Account created successfully',
    invalid_credentials: 'Invalid credentials',

    wizard_title: 'Family Registration',
    wizard_subtitle: 'Complete your details to access El Club de Manri',
    step_family: 'Family Data',
    step_phone: 'Verify Phone',
    step_pool: 'Pool Map',
    step_consents: 'Consents',
    step_confirm: 'Confirmation',
    family_data_title: 'Family Details',
    room_number_label: 'Email address',
    children_label: 'Children',
    add_child: 'Add',
    child_name: 'Name',
    child_age: 'Age',
    phone_title: 'Phone Verification',
    phone_subtitle: 'Enter your number to receive an SMS code',
    send_sms: 'Send SMS',
    sending: 'Sending...',
    sms_sent: 'SMS code sent (simulated)',
    test_code: 'Test code (simulated SMS)',
    verify_code: 'Verify Code',
    verifying: 'Verifying...',
    phone_verified: 'Phone verified',
    verify_first: 'Verify your phone first',
    pool_title: 'Pool Map',
    pool_subtitle: 'Select a zone or click on the free area to indicate your location',
    pool_location: 'Location',
    pool_zone: 'Zone',
    pool_free: 'Free position',
    select_location: 'Select your location on the map',
    signatures_title: 'Digital Signatures',
    signatures_subtitle: 'Sign the following documents with your finger or stylus',
    auth_title: 'General Authorization',
    auth_text: 'I authorize my child(ren) to participate in the El Club de Manri hotel activities, including workshops, games, and activities supervised by monitors.',
    terms_title: 'Terms & Conditions',
    terms_text: 'I accept the terms and conditions of the El Club de Manri service, including behavior rules, schedules, and responsibilities.',
    image_title: 'Image Rights',
    image_text: 'I authorize the hotel to capture and use photographs and videos of my child(ren) during El Club de Manri activities for promotional purposes.',
    sign_instruction: 'Sign with your finger or stylus in the area above',
    all_signatures_required: 'All signatures are required',
    confirm_title: 'All set!',
    confirm_subtitle: 'Review your data and confirm registration',
    family_label: 'Family',
    phone_label: 'Phone',
    verified: 'verified',
    documents_signed: 'documents signed',
    complete_registration: 'Confirm Registration',
    completing: 'Completing...',
    registration_complete: 'Registration complete!',
    saving: 'Saving...',
    fill_name_room: 'Fill in name and email',
    add_one_child: 'Add at least one child',

    tab_workshops: 'Workshops',
    tab_reservations: 'My Bookings',
    tab_history: 'History',
    workshops_available: 'Available Workshops',
    calendar_view: 'Calendar',
    list_view: 'List',
    no_reservations: 'No active bookings',
    my_reservations: 'My Bookings',
    cancel_reservation: 'Cancel Booking',
    reservation_confirmed: 'Confirmed',
    checked_in: 'Checked in',
    book: 'Book',
    reserved: 'Booked',
    full: 'Full',
    capacity: 'spots',
    ages: 'Ages',
    years: 'years',
    select_children: 'Select Children',
    confirm_booking: 'Confirm Booking',
    booking_confirmed: 'Booking confirmed!',
    select_one_child: 'Select at least one child',
    reservation_cancelled: 'Booking cancelled',
    workshop_full: 'Workshop full',

    history_title: 'Activity History',
    activities: 'Activities',
    attendances: 'Attendances',
    total_hours: 'Total Hours',
    unique_workshops: 'Unique Workshops',
    child_progress: 'Progress per Child',
    workshops_count: 'workshops',
    timeline: 'Activity Timeline',
    attended: 'Attended',
    no_activities: 'No activities yet',
    activities_appear_here: 'Bookings and activities will appear here',
    participants: 'Participants',

    rate_workshop: 'Rate this workshop',
    how_was_experience: 'How was the experience?',
    write_comment: 'Write a comment (optional)...',
    send: 'Send',

    workshops_this_week: 'workshops this week',
    workshop_singular: 'workshop',
    today: 'Today',
    filter: 'Filter',
    all: 'All',
    none: 'None',
    categories_of: 'of',
    categories: 'categories',
    no_workshops_day: 'No workshops this day',
    no_workshops_week: 'No workshops this week',
    navigate_hint: 'Navigate to another week with the arrows',

    zona_a: 'Zone A', zona_b: 'Zone B', zona_c: 'Zone C', zona_d: 'Zone D', zona_e: 'Zone E',
    main_pool: 'Main Pool', kids_pool: 'Kids Pool',

    pool_click_hint: 'Click on the map to mark the location',
    pool_main: 'Main Pool',
    pool_2: 'Pool 2',
    pool_3: 'Pool 3',
    location_marked: 'Location marked',

    admin_title: 'Admin',
    admin_subtitle: 'Administration panel',
    export_pdf: 'Export PDF',
    workshop_management: 'Workshop Management',
    new_workshop: 'New Workshop',
    create_workshop: 'Create Workshop',
    update_workshop: 'Update Workshop',
    access_type: 'Access type',
    mandatory_registration: 'Mandatory registration',
    free_access: 'Free access',
    families_must_book: 'Families must book a place for this activity',
    families_can_access: 'Families can access without prior booking',
    schedule: 'Schedule',
    morning: 'AM - Morning',
    afternoon: 'PM - Afternoon',
    materials_needed: 'Materials needed',
    materials_placeholder: 'E.g.: Paints, brushes, paper...',
    pool_zone_label: 'Pool zone',
    drive_link_label: 'Google Drive link (resources)',
    mandatory_badge: 'Required',
    free_badge: 'Free',
    tab_talleres: 'Workshops',
    tab_calendario: 'Calendar',
    tab_familias: 'Families',
    tab_reservas: 'Bookings',
    tab_valoraciones: 'Reviews',
    tab_qr: 'QR Code',

    monitor_title: 'Monitor',
    monitor_subtitle: 'Daily control panel',
    reservations_today: 'Bookings Today',
    checkins: 'Check-ins',
    active_workshops: 'Active Workshops',
    families: 'Families',
    tab_checkin: 'Check-in',
    tab_schedule_today: 'Today Schedule',
    tab_tomorrow: 'Tomorrow',
    workshops_of_day: 'Workshops of the Day',
    activities_today: 'Today Activities',
    activities_tomorrow: 'Tomorrow Activities',
    no_activities_today: 'No activities scheduled for today',
    no_activities_tomorrow: 'No activities scheduled for tomorrow',
    search_family: 'Search family...',
    no_reservations_filter: 'No bookings',
    no_reservations_workshop: 'No bookings for this workshop',
    present: 'Present',
    filter_btn: 'Filter',
    filtered: 'Filtered',
    reservations_count: 'bookings',
    spots: 'spots',
    registration_label: 'Required',
    free_label: 'Free',
    resources: 'Resources',

    description_label: 'Description',
    no_description: 'No description',
    materials_section: 'MATERIALS NEEDED',
    not_specified: 'Not specified',
    location_label: 'LOCATION',
    not_assigned: 'NOT ASSIGNED',
    open_drive: 'Open Google Drive folder',
    drive_resources: 'Digital resources and activity files',
    drive_not_configured: 'No link configured',
    google_drive: 'Google Drive',
    photos: 'Photos',
    no_photos: 'No photos attached',
    no_digital_resources: 'No digital resources attached to this activity',
    qr_today_label: 'Today',
    years_old: 'years',

    login_hero: 'Kids activities and workshops management',

    parent_name_label: 'Parent/Guardian name',
    dni_label: 'ID / Passport',
    parent_required: 'Parent/Guardian name is required',
    dni_required: 'ID/Passport is required',
    email_password_required: 'Email and password are required',
    qr_verified: 'QR Verified',
  },

  de: {
    app_name: 'El Club de Manri',
    save: 'Speichern',
    cancel: 'Abbrechen',
    next: 'Weiter',
    previous: 'Zuruck',
    confirm: 'Bestatigen',
    loading: 'Laden...',
    error: 'Fehler',
    logout: 'Abmelden',
    close: 'Schliessen',
    search: 'Suchen',
    welcome: 'Willkommen',
    room: 'E-Mail',

    login_title: 'Anmelden',
    login_subtitle: 'Zugang zu Ihrem El Club de Manri-Konto',
    register_title: 'Konto erstellen',
    register_subtitle: 'Registrieren Sie Ihre Familie fur Workshops',
    email_label: 'E-Mail',
    password_label: 'Passwort',
    family_name_label: 'Familienname',
    login_button: 'Anmelden',
    register_button: 'Konto erstellen',
    toggle_to_register: 'Kein Konto - Registrieren',
    toggle_to_login: 'Bereits registriert - Anmelden',
    login_hero_text: 'Verwaltung von Kinderaktivitaten und Workshops inspiriert von Cesar Manrique',
    account_created: 'Konto erfolgreich erstellt',
    invalid_credentials: 'Ungultige Anmeldedaten',

    wizard_title: 'Familienregistrierung',
    wizard_subtitle: 'Fullen Sie Ihre Daten aus um auf den El Club de Manri zuzugreifen',
    step_family: 'Familiendaten',
    step_phone: 'Telefon verifizieren',
    step_pool: 'Poolkarte',
    step_consents: 'Einwilligungen',
    step_confirm: 'Bestatigung',
    family_data_title: 'Familiendaten',
    room_number_label: 'E-Mail-Adresse',
    children_label: 'Kinder',
    add_child: 'Hinzufugen',
    child_name: 'Name',
    child_age: 'Alter',
    phone_title: 'Telefonverifizierung',
    phone_subtitle: 'Geben Sie Ihre Nummer ein um einen SMS-Code zu erhalten',
    send_sms: 'SMS senden',
    sending: 'Sende...',
    sms_sent: 'SMS-Code gesendet (simuliert)',
    test_code: 'Testcode (simulierte SMS)',
    verify_code: 'Code verifizieren',
    verifying: 'Verifiziere...',
    phone_verified: 'Telefon verifiziert',
    verify_first: 'Verifizieren Sie zuerst Ihr Telefon',
    pool_title: 'Poolkarte',
    pool_subtitle: 'Wahlen Sie eine Zone oder klicken Sie frei um Ihren Standort anzugeben',
    pool_location: 'Standort',
    pool_zone: 'Zone',
    pool_free: 'Freie Position',
    select_location: 'Wahlen Sie Ihren Standort auf der Karte',
    signatures_title: 'Digitale Unterschriften',
    signatures_subtitle: 'Unterschreiben Sie die folgenden Dokumente mit Ihrem Finger oder Stift',
    auth_title: 'Allgemeine Genehmigung',
    auth_text: 'Ich ermaechtige mein(e) Kind(er) an den Aktivitaten des El Club de Manri Hotels teilzunehmen, einschliesslich Workshops, Spiele und beaufsichtigte Aktivitaten.',
    terms_title: 'Allgemeine Geschaftsbedingungen',
    terms_text: 'Ich akzeptiere die AGB des El Club de Manri-Service, einschliesslich Verhaltensregeln, Zeitplane und Verantwortlichkeiten.',
    image_title: 'Bildrechte',
    image_text: 'Ich ermaechtige das Hotel Fotos und Videos meines/meiner Kind(er) wahrend der El Club de Manri-Aktivitaten fur Werbezwecke aufzunehmen und zu verwenden.',
    sign_instruction: 'Unterschreiben Sie mit dem Finger oder Stift im oberen Bereich',
    all_signatures_required: 'Alle Unterschriften sind erforderlich',
    confirm_title: 'Alles bereit!',
    confirm_subtitle: 'Uberprufen Sie Ihre Daten und bestatigen Sie die Registrierung',
    family_label: 'Familie',
    phone_label: 'Telefon',
    verified: 'verifiziert',
    documents_signed: 'Dokumente unterschrieben',
    complete_registration: 'Registrierung bestatigen',
    completing: 'Wird abgeschlossen...',
    registration_complete: 'Registrierung abgeschlossen!',
    saving: 'Speichere...',
    fill_name_room: 'Name und E-Mail ausfullen',
    add_one_child: 'Mindestens ein Kind hinzufugen',

    tab_workshops: 'Workshops',
    tab_reservations: 'Meine Buchungen',
    tab_history: 'Verlauf',
    workshops_available: 'Verfugbare Workshops',
    calendar_view: 'Kalender',
    list_view: 'Liste',
    no_reservations: 'Keine aktiven Buchungen',
    my_reservations: 'Meine Buchungen',
    cancel_reservation: 'Buchung stornieren',
    reservation_confirmed: 'Bestatigt',
    checked_in: 'Eingecheckt',
    book: 'Buchen',
    reserved: 'Gebucht',
    full: 'Ausgebucht',
    capacity: 'Platze',
    ages: 'Alter',
    years: 'Jahre',
    select_children: 'Kinder auswahlen',
    confirm_booking: 'Buchung bestatigen',
    booking_confirmed: 'Buchung bestatigt!',
    select_one_child: 'Mindestens ein Kind auswahlen',
    reservation_cancelled: 'Buchung storniert',
    workshop_full: 'Workshop ausgebucht',

    history_title: 'Aktivitatsverlauf',
    activities: 'Aktivitaten',
    attendances: 'Anwesenheiten',
    total_hours: 'Gesamtstunden',
    unique_workshops: 'Einzigartige Workshops',
    child_progress: 'Fortschritt pro Kind',
    workshops_count: 'Workshops',
    timeline: 'Aktivitatszeitleiste',
    attended: 'Teilgenommen',
    no_activities: 'Noch keine Aktivitaten',
    activities_appear_here: 'Buchungen und Aktivitaten erscheinen hier',
    participants: 'Teilnehmer',

    rate_workshop: 'Workshop bewerten',
    how_was_experience: 'Wie war das Erlebnis?',
    write_comment: 'Kommentar schreiben (optional)...',
    send: 'Senden',

    workshops_this_week: 'Workshops diese Woche',
    workshop_singular: 'Workshop',
    today: 'Heute',
    filter: 'Filter',
    all: 'Alle',
    none: 'Keine',
    categories_of: 'von',
    categories: 'Kategorien',
    no_workshops_day: 'Keine Workshops an diesem Tag',
    no_workshops_week: 'Keine Workshops diese Woche',
    navigate_hint: 'Mit den Pfeilen zu einer anderen Woche navigieren',

    zona_a: 'Zone A', zona_b: 'Zone B', zona_c: 'Zone C', zona_d: 'Zone D', zona_e: 'Zone E',
    main_pool: 'Hauptpool', kids_pool: 'Kinderpool',

    pool_click_hint: 'Klicken Sie auf die Karte um den Standort zu markieren',
    pool_main: 'Hauptpool',
    pool_2: 'Pool 2',
    pool_3: 'Pool 3',
    location_marked: 'Standort markiert',

    admin_title: 'Admin',
    admin_subtitle: 'Verwaltungspanel',
    export_pdf: 'PDF exportieren',
    workshop_management: 'Workshop-Verwaltung',
    new_workshop: 'Neuer Workshop',
    create_workshop: 'Workshop erstellen',
    update_workshop: 'Workshop aktualisieren',
    access_type: 'Zugangsart',
    mandatory_registration: 'Anmeldung erforderlich',
    free_access: 'Freier Zugang',
    families_must_book: 'Familien mussen einen Platz fur diese Aktivitat buchen',
    families_can_access: 'Familien konnen ohne Voranmeldung teilnehmen',
    schedule: 'Zeitplan',
    morning: 'AM - Morgen',
    afternoon: 'PM - Nachmittag',
    materials_needed: 'Benotigte Materialien',
    materials_placeholder: 'Z.B.: Farben, Pinsel, Papier...',
    pool_zone_label: 'Pool-Zone',
    drive_link_label: 'Google Drive Link (Ressourcen)',
    mandatory_badge: 'Pflicht',
    free_badge: 'Frei',
    tab_talleres: 'Workshops',
    tab_calendario: 'Kalender',
    tab_familias: 'Familien',
    tab_reservas: 'Buchungen',
    tab_valoraciones: 'Bewertungen',
    tab_qr: 'QR-Code',

    monitor_title: 'Monitor',
    monitor_subtitle: 'Tagliches Kontrollpanel',
    reservations_today: 'Buchungen Heute',
    checkins: 'Check-ins',
    active_workshops: 'Aktive Workshops',
    families: 'Familien',
    tab_checkin: 'Check-in',
    tab_schedule_today: 'Zeitplan Heute',
    tab_tomorrow: 'Morgen',
    workshops_of_day: 'Workshops des Tages',
    activities_today: 'Aktivitaten Heute',
    activities_tomorrow: 'Aktivitaten Morgen',
    no_activities_today: 'Keine Aktivitaten fur heute geplant',
    no_activities_tomorrow: 'Keine Aktivitaten fur morgen geplant',
    search_family: 'Familie suchen...',
    no_reservations_filter: 'Keine Buchungen',
    no_reservations_workshop: 'Keine Buchungen fur diesen Workshop',
    present: 'Anwesend',
    filter_btn: 'Filtern',
    filtered: 'Gefiltert',
    reservations_count: 'Buchungen',
    spots: 'Platze',
    registration_label: 'Pflicht',
    free_label: 'Frei',
    resources: 'Ressourcen',

    description_label: 'Beschreibung',
    no_description: 'Keine Beschreibung',
    materials_section: 'BENOTIGTE MATERIALIEN',
    not_specified: 'Nicht angegeben',
    location_label: 'STANDORT',
    not_assigned: 'NICHT ZUGEWIESEN',
    open_drive: 'Google Drive Ordner offnen',
    drive_resources: 'Digitale Ressourcen und Aktivitatsdateien',
    drive_not_configured: 'Kein Link konfiguriert',
    google_drive: 'Google Drive',
    photos: 'Fotos',
    no_photos: 'Keine Fotos angehangt',
    no_digital_resources: 'Keine digitalen Ressourcen fur diese Aktivitat',
    qr_today_label: 'Heute',
    years_old: 'Jahre',

    login_hero: 'Verwaltung von Kinderaktivitaten und Workshops',

    parent_name_label: 'Name des Elternteils/Erziehungsberechtigten',
    dni_label: 'Ausweis / Reisepass',
    parent_required: 'Name des Elternteils ist erforderlich',
    dni_required: 'Ausweis/Reisepass ist erforderlich',
    email_password_required: 'E-Mail und Passwort sind erforderlich',
    qr_verified: 'QR Verifiziert',
  },
};

export default translations;
